import React from 'react';

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('ImageEditor crashed:', error, info);
    }

    handleReload = () => {
        this.setState({ hasError: false, error: null });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh',
                        gap: '16px',
                        fontFamily: 'Poppins, sans-serif',
                        color: '#1f2a44',
                        textAlign: 'center',
                        padding: '24px',
                    }}
                >
                    <h2 style={{ margin: 0 }}>Something went wrong</h2>
                    <p style={{ margin: 0, maxWidth: 480, color: '#5b6577' }}>
                        The image editor ran into an unexpected error. Reloading usually fixes it.
                    </p>
                    {this.state.error?.message && (
                        <pre
                            style={{
                                maxWidth: 640,
                                whiteSpace: 'pre-wrap',
                                background: '#f4f5f9',
                                padding: '12px 16px',
                                borderRadius: 8,
                                fontSize: 12,
                                color: '#8a2331',
                            }}
                        >
                            {this.state.error.message}
                        </pre>
                    )}
                    <button
                        onClick={this.handleReload}
                        style={{
                            cursor: 'pointer',
                            border: 'none',
                            borderRadius: 8,
                            padding: '10px 20px',
                            background: '#ef5d8f',
                            color: '#fff',
                            fontWeight: 600,
                        }}
                    >
                        Reload editor
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
